/* The native Shopify localization form remains usable without JavaScript. */
document.addEventListener('change', (event) => {
  const select = event.target.closest('.enginora-language select[name="language_code"]');
  if (select && select.form) {
    if (typeof select.form.requestSubmit === 'function') select.form.requestSubmit();
    else select.form.submit();
  }
});
